// @ts-expect-error - Automatic, Please fix when editing this file
const unfixFpIterator = (fn) => fn.convert({ fixed: false });

export default unfixFpIterator;
